import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { rpc } from '../../api/rpc'
import { Modal } from '../ui/Modal'
import { Spinner } from '../ui/Spinner'
import type { KbPassageRef } from './citations'

interface ReadResult { title: string; chunks: { ord: number; headingPath: string; page: number | null; text: string }[]; total: number }

/** Shows a cited passage with one chunk of context on each side (kb.read). */
export function CitationModal({ passage, onClose }: { passage: KbPassageRef | null; onClose(): void }) {
  const { t } = useTranslation()
  const [data, setData] = useState<ReadResult | null>(null)
  const [error, setError] = useState<string | null>(null)
  useEffect(() => {
    setData(null); setError(null)
    if (passage) rpc.call<ReadResult>('kb.read', { ref: passage.ref }).then(setData).catch(err => setError((err as Error).message))
  }, [passage])
  const center = passage ? Number(passage.ref.split('#')[1]) : -1
  const where = passage ? [passage.headingPath, passage.page !== null ? t('kb.page', { page: passage.page }) : '', passage.collection].filter(Boolean).join(' · ') : ''
  return (
    <Modal open={passage !== null} wide title={passage ? `[${passage.n}] ${passage.title}` : ''} description={where} onClose={onClose}>
      {error ? <p className="text-sm text-red-600">{error}</p> : !data ? <div className="flex justify-center py-6"><Spinner /></div> : (
        <div className="space-y-3">
          {data.chunks.map(c => (
            <p key={c.ord} className={c.ord === center ? 'whitespace-pre-wrap rounded-[10px] border border-line bg-ginger-50 p-3 text-sm text-ink-200' : 'whitespace-pre-wrap px-3 text-sm text-ink-500'}>{c.text}</p>
          ))}
        </div>
      )}
    </Modal>
  )
}
